import { axiosInstance } from "../axios/axiosConfig";

const controller = "TrainersSmartMatching";

export const storedSmartMatching = async (request) => {
    try {
        const response = await axiosInstance.post(
            `${controller}/stored`,
            request,
            {
                headers: {
                    'X-Skip-Loading': true
                }
            }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getCurrentSmartMatchingTrainer = async (request) => {
    const response = await axiosInstance.post(`/${controller}/matching`, request);
    return response.data;
}

export const getCurrentSmartMatching = async () => {
    const response = await axiosInstance.get(`/${controller}/stored`);
    return response.data;
}